import { NAME } from './constants';

export const SET_SUMMARY = `${NAME}/SET_SUMMARY`;
export const REMOVE_SUMMARY = `${NAME}/REMOVE_SUMMARY`;
export const SAVE_LAST_SUMMARY_REQUEST = `${NAME}/SAVE_LAST_SUMMARY_REQUEST`;
